export default __webpack_public_path__ + "static/media/032-red envelope.809e3d3a.svg";